// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum WeaponTypeId {
  None = 0,
  InfantryMachineGun = 100,
  VehicleMachineGun = 101,
  AntiAirCannon = 102,
  TankCannon = 300,
  ArtillaryCannon = 400,
  Rocket = 600,
  Missile = 900
}
